import useTranslation from "@hooks/use_translation";
import { Body } from "@sprout/typography";
import Toggle from "@/sprout/toggle";
import DreamJobIcon from "@/sprout/icons/dream_job";
import "@/stylesheets/dream_job_icon.scss";

interface Props {
  marked: boolean;
  onChange: (marked: boolean) => void;
}

const ApplicationDreamJobBanner = ({ marked, onChange }: Props) => {
  const { t } = useTranslation("job_post", {
    keyPrefix: "application.dream_job",
  });

  return (
    <div className="flex flex-col gap-4 w-full bg-marigold-25 border border-marigold-e50 rounded-lg px-4 py-4 md:flex-row md:items-center md:justify-between md:px-6">
      <div className="flex items-start gap-3">
        <div className="bg-marigold-e50 dream-job-icon shrink-0 hidden md:block">
          <DreamJobIcon size={"md"} color="dark-green" />
        </div>
        <div className="flex flex-col gap-0.5">
          <Body medium className="text-sm! md:text-base! text-dark-green">
            {t("header")}
          </Body>
          <Body secondary className="text-xs! md:text-sm! text-dark-green">
            {t("body")}
          </Body>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <Toggle checked={marked} onChange={onChange} ariaLabel={t("header")} />
        <Body className="text-sm! md:text-base! text-dark-green whitespace-nowrap">
          <span className="grid">
            <span className="col-start-1 row-start-1">
              {marked ? t("toggle_on") : t("toggle_off")}
            </span>
            {/* Render the other label invisibly so we always reserve the width of the longest label to prevent it from shifting when toggled */}
            <span aria-hidden className="invisible col-start-1 row-start-1">
              {marked ? t("toggle_off") : t("toggle_on")}
            </span>
          </span>
        </Body>
      </div>
    </div>
  );
};

export default ApplicationDreamJobBanner;
